module.exports = {
    JwtDecode: function JwtDecode(token) {
        if(!token) {
            return null;
        }
        
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace('-', '+').replace('_', '/');
            const obj = JSON.parse(window.atob(base64));
            return obj;
        } catch (error) {
            // TODO: log the error here
            return null;
        }
    }
};
